// GraphQL queries for authentication
import { USER_FRAGMENT } from '../fragments/auth';

export const ME_USER_QUERY = `
  query meUser {
    meUser {
      user {
        ${USER_FRAGMENT}
      }
    }
  }
`;